import Vue from 'vue';
import Vuex from 'vuex';
import { set, toggle } from "./vuex-utils";
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        layout: "non-authenticated-layout",
        drawer: true,
        color: "success",
        mini: true,
        user: null
    },
    mutations: {
        SET_LAYOUT(state, payload) {
            state.layout = payload;
        },
        SET_DRAWER(state, payload) {
            console.log('Setting drawer to ' + payload);
            state.drawer = payload;
        },
        setUser: set("user"),
        setDrawer: set("drawer"),
        setMini: set("mini"),
        toggleMini: toggle("mini"),
        setImage: set("image"),
        setColor: set("color"),
        toggleDrawer: toggle("drawer")
    },
    getters: {
        layout(state) {
            return state.layout;
        },
        user(state) {
            return state.user;
        }
    },
    actions: {},
    modules: {}
});
